/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://maps.tippecanoe.in.gov/portal/jsapi/jsapi4/esri/copyright.txt for details.
*/
var e;!function(e){e[e.Layer=0]="Layer",e[e.Object=1]="Object",e[e.Mesh=2]="Mesh",e[e.Line=3]="Line",e[e.Point=4]="Point",e[e.Material=5]="Material",e[e.Texture=6]="Texture",e[e.COUNT=7]="COUNT"}(e||(e={}));export{e as ContentObjectType};
